import styled from '@emotion/styled';
import { LazyImageSilk } from 'src/domains/sportsbook/webview/components/lazyImage/LazyImageSilk';
import { withConfig } from 'src/withConfig';

export const SilkCastWrapper = withConfig(theme => styled('div', { label: 'SilkCastWrapper' })`
    align-items: center;
    display: flex;
    justify-content: center;
    flex: 0 0 64px;
    img[src*='empty-hr-silk'] {
        width: 32px;
    }
    @media ${theme.star.mediaQuery.tablet} {
        flex: 0 0 80px;
        margin-right: -16px;
    }
`);

export const SilkCast = withConfig(theme => styled(LazyImageSilk, { label: 'SilkCast' })`
    width: 40px;
    @media ${theme.star.mediaQuery.tablet} {
        width: 50px;
    }
`);
